import React, { useState } from 'react';
import PortfolioModal from './portfolio_modal';
import { VISIBLE_PORTFOLIOS } from './constants/magic_numbers';

const Portfolio = ({ portfolios }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPortfolio, setSelectedPortfolio] = useState(null);
    const [visibleImageCount, setVisibleImageCount] = useState(VISIBLE_PORTFOLIOS);

    const handlePhotoClick = (portfolio) => {
        setSelectedPortfolio(portfolio);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedPortfolio(null);
    };

    const handleMoreButtonClick = () => {
        setVisibleImageCount((prev) => prev + VISIBLE_PORTFOLIOS);
    };

    return (
        <>
            <div className="concept-story">
                <div className="heading--2">
                    <h2 className="heading__text color--accent font-family--large">思い出のストーリー</h2>
                </div>

                <ul className="concept-story__list">
                    {/* 画像を初期状態で4枚表示し、もっと見るボタンで4枚ずつ追加表示 */}
                    {portfolios.slice(0, visibleImageCount).map((portfolio) => (
                        <li className="concept-story__item" key={portfolio.id}>
                            <div onClick={() => handlePhotoClick(portfolio)}>
                                <figure className="concept-story__img">
                                    <img
                                        src={portfolio.image.thumbnail_image_url}
                                        alt={`${portfolio.staff.name}の思い出のストーリー`}
                                        width="157"
                                        height="157"
                                        loading="lazy"
                                    />
                                </figure>
                            </div>
                        </li>
                    ))}
                </ul>
                {visibleImageCount < portfolios.length && (
                    <button
                        className="concept-btn-more border-color--border background-color--page_bg color--sub border-radius--btn font-family--middle"
                        onClick={handleMoreButtonClick}
                    >
                        もっと見る
                    </button>
                )}
            </div>
            {isModalOpen && selectedPortfolio && (
                <PortfolioModal
                    portfolios={portfolios}
                    selectedPortfolio={selectedPortfolio}
                    onClose={handleCloseModal}
                />
            )}
        </>
    );
};

export default Portfolio;
